import { functions } from "./firebase";

const CALLABLE_TIMEOUT_MS = 20_000;

/**
 * Set facilitySubtypes on a location (facility-data-admin roles only).
 *
 * @param {{ locationId: string, subtypes: string[] }} params
 */
export async function adminSetFacilitySubtypes({ locationId, subtypes }) {
  const callable = functions.httpsCallable("adminSetFacilitySubtypes", {
    timeout: CALLABLE_TIMEOUT_MS,
  });
  const response = await callable({ locationId, subtypes });
  return response?.data || null;
}
